import React from "react"
import { injectIntl } from "react-intl"
import { Link } from "react-router"
import { getAccountSettings } from "../../scripts/accountSettings"
import Image from "./Image"
import settingsMessages from "../../messages/settings"

export const LoginLogo = props => {
  const { logo, name } = getAccountSettings(
    props.intl.formatMessage(settingsMessages.authenticAccountId)
  )
  return (
    <div className="pull-left">
      <div className="logo site-header__col site-header__col--logo">
        <Link to="/" className="site-header__col-inner">
          <Image
            className="logo__image"
            src={logo ? logo.url : ""}
            alt={name}
          />
          {/* <div className="logo__wordmark">
            <div className="logo__name">{accountSettings.name || ''}</div>
          </div> */}
        </Link>
      </div>
    </div>
  )
}

export default injectIntl(LoginLogo)



// WEBPACK FOOTER //
// ./webapp/components/elements/LoginLogo.js